<style scoped>
[contenteditable]:focus {
  outline: 0px solid transparent;
}

.tab-sheet {
  font-size: 10px;
  border-top: 0.5px solid #ccc;
  border-right: 0.5px solid #ccc;
  border-left: 0.5px solid #ccc;
  width: 100%;
  cursor: pointer;
}

.tab-sheet:last {
  border-bottom: 0.5px solid #ccc;
}


.tab-sheet.active {
  border-left: 5px solid #4CAF50;
  color: #4CAF50;
}

.tab-sheet .text {
  padding: 5px 20px 5px 20px;
}

.bottom-nav {
  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 0;
  float: left;
  width: 100%;
  background-color: #fff;
}

.bottom-nav div {
  display: block;
  float: left;
  width: auto;
  cursor: pointer;
}

.spread-sheet {
  margin-bottom: 5px;
}

.sticky-menu {
  position: absolute;
  left: 0px;
  top: 0px;
  width: auto;
  z-index: 80;
  height: 60px;
  border-bottom: 0px solid #ccc;
  background-color: #fff;

}
</style>

<template>
<div style="min-height: 100%; border: 0px solid red">
  <v-layout row justify-center>
    <v-dialog v-model="dialogDeleteWorksheet" max-width="50%">
      <v-card>
        <v-card-title class="headline">Do you want to delete worksheet : {{ dataSource.name }}?</v-card-title>

        <v-card-text>
          Click Yes to proceed.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat="flat" @click="dialogDeleteWorksheet = false">
            Cancel
          </v-btn>

          <v-btn color="green darken-1" flat="flat" @click="aDelete(dataSource); dialogDeleteWorksheet = false">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  <v-layout row justify-center>
    <v-dialog v-model="dialogDeleteProject" max-width="50%">
      <v-card>
        <v-card-title class="headline">Do you want to this project ?</v-card-title>

        <v-card-text>
          This will delete all worksheets and dashboards. Click Yes to proceed.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat="flat" @click="dialogDeleteProject = false">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="deleteProject(); dialogDeleteProject = false">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  <v-container fluid fill-height class="spread-sheet" v-if="dataSource && dataSource.type" style="padding-top: 0px; padding-left: 0px; padding-right: 0px; background-color: #fff">
    <div class="sticky-menu">
      <!--
      <v-tooltip bottom>

        <template v-slot:activator="{ on }">
          <v-btn flat icon color="grey" v-on="on" v-on:click="mToggleGridMenu()">
            <v-icon>code</v-icon>
          </v-btn>
        </template>
        <span>SQL Query</span>
      </v-tooltip>
    -->



    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          color="blue-grey"
          class="white--text"
          v-on:click="aAdd()"
        >
          Add Worksheet
        </v-btn>
      </template>
      <span>Add Worksheet</span>
    </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn flat color="indigo" v-on="on" v-on:click="aUpdate(dataSource)">
            Save &nbsp; <v-icon>save</v-icon>
          </v-btn>
        </template>
        <span>Save Worksheet</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn flat icon color="pink" v-on="on" v-on:click="dialogDeleteWorksheet = true">
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
        <span>Delete Worksheet</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn white icon color="pink" v-on="on" v-on:click="dialogDeleteProject = true;">
            <v-icon color="white">delete</v-icon>
          </v-btn>
        </template>
        <span>Delete Project</span>
      </v-tooltip>


    </div>


    <v-layout row wrap justify-start align-left text-xs-left v-if="dataSource.type == 'default'">
      <v-flex xs12 sm12 style="padding-left: 10px">
        <list row wrap />
      </v-flex>
    </v-layout>
    <v-layout class="mb-2" row wrap justify-start align-left text-xs-left v-if="dataSource && dataSource.type != 'default'">
      <v-flex xs12 sm12>
        <v-card>
          <data-source />
        </v-card>
      </v-flex>

      <v-flex xs2 fill-height style="height: 100%; margin-top: 20px; padding: 5px 15px 0px 5px;">
        <!--
        <div><v-text-field label="Worksheet" placeholder=" "></v-text-field></div>
      -->
      <span class="subheading font-weight-bold">Worksheets</span>

        <!--
      <div class="bottom-nav">
      </div>
    -->
        <!--<div class="bottom-icon text-xs-center" v-on:click="aAdd()"><v-icon class="text-xs-center">add</v-icon></div>-->
        <div v-for="item in dataSources" v-bind:key="item.id" class="text-xs-left tab-sheet" v-on:click="mSetDataSource(item)" v-bind:class="{ active: item.id === dataSource.id }">
          <div autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" contenteditable="true" @blur="updateName" class="text">{{ item.name }}</div>
        </div>
      </v-flex>

      <v-flex xs10 fill-height style="height: 100%">
        <preview />
      </v-flex>
    </v-layout>

  </v-container>
  <v-container v-else>
    <v-layout row wrap justify-start align-left text-xs-left>
      <v-flex xs12 sm12>
        <upload-file />
      </v-flex>
    </v-layout>

  </v-container>


</div>
</template>

<script>
// import SpreadSheet from '@/components/data/SpreadSheet.vue';
const SpreadSheet = () => import('@/components/data/SpreadSheet.vue');
// import SQL from '@/components/data/SQL.vue';
const SQL = () => import('@/components/data/SQL.vue');
// import DataSource from '@/components/data/DataSource.vue';
const DataSource = () => import('@/components/data/DataSource.vue');
// import List from '@/components/data/List.vue';
const List = () => import('@/components/data/List.vue');
// import Preview from '@/components/data/Preview.vue';
const Preview = () => import('@/components/data/Preview.vue');
// import UploadFile from '@/components/data/UploadFile.vue';
const UploadFile = () => import('@/components/data/UploadFile.vue');
// import Connection from '@/components/data/Connection.vue';
const Connection = () => import('@/components/data/Connection.vue');
import {deleteProject} from '@/models/project';
import dataSources from '@/store/modules/data-sources';

import {
  createNamespacedHelpers
}
from 'vuex'
// const {
//   mapState,
//   mapActions,
//   mapGetters,
//   mapMutations
// } = createNamespacedHelpers('dataSources')

const dataSourceNamespace = createNamespacedHelpers('dataSources');

export default {
  name: 'data-sources',
  data: function() {
    return {
      dialogDeleteWorksheet: false,
      dialogDeleteProject: false,
      settings: {
        maxScrollbarLength: 60
      }
    }
  },
  components: {
    'spread-sheet': SpreadSheet,
    'sql': SQL,
    'data-source': DataSource,
    'list': List,
    'preview': Preview,
    'upload-file': UploadFile,
    'connection': Connection
  },
  computed: {
    ...dataSourceNamespace.mapState(['dataSources', 'dataSource'])
  },
  methods: {
    ...dataSourceNamespace.mapMutations(['mAdd', 'mSetDataSource', 'mSetName', 'mSetType', 'mDelete', 'mSave', 'mSetProjectId']),
    ...dataSourceNamespace.mapActions(['aAdd', 'aSetDataSource', 'aInit', 'aUpdate', 'aDelete']),
    setDataSource: function(dataSource) {
      this.mSetDataSource(dataSource);
    },
    updateName: function(event) {
      this.mSetName(event.target.innerText);
    },
    async deleteProject() {
      await deleteProject(this.$route.params.projectId);
      this.$router.push({name: 'projects-home'});
    }
  },
  mounted: function() {
    this.mSetProjectId(this.$route.params.projectId);
    this.aInit(this.dataSource);
  },
  beforeCreate: function() {
    if(typeof this.$store.state['dataSources'] == 'undefined') {
      this.$store.registerModule('dataSources', dataSources);
    }
  },
  beforeDestroy () {
   // this.$store.unregisterModule('dataSources');
  }
}
</script>
